/**
 * Merges buildings.json data with panelSettings phasing_config.buildings data using building id_cad to produce a list of buildings with phasing data fields.
 * 
 * @param {object[]} buildings       - array from buildings.json → `.buildings`
 * @param {object[]} tiers           - array of tiers from context
 * @param {object[]} panelSettings   - array of CMS panel settings objects (from panel-settings.json)
 * @returns {{ ref_tier: number, name_original: string, id_cad: string, building_id: string }[]}
 */
export function buildBuildingsData(buildings, tiers = [], panelSettings) {
  if (!buildings?.length) return []

  const phasingConfig = panelSettings?.phasing_config?.buildings ?? []
  const enhancedBuildings = buildings.map((building) => {
    const buildingId = building.id_cad
    const buildingPhasing = phasingConfig.find((bp) => bp.id_cad === buildingId)
    const buildingTires = tiers.filter((t) => t.building_id === buildingId)

    const hasActiveTiers = buildingTires.length > 0
      ? buildingTires.some((t) => t.isActive)
      : true

    const isSoldOut = buildingTires.every((t) => t.isSoldOut)

    return {
      ...building,
      ...buildingPhasing,
      hasActiveTiers: hasActiveTiers,
      isSoldOut,
    }
  })

  return enhancedBuildings
}